module.exports = "<div class=\"top-text\">\n  <h2 class=\"title\">\n    {{ $ctrl.information.title | translate }}\n  </h2>\n  <span class=\"subtitle\">\n    {{ $ctrl.information.subtitle | translate }}\n  </span>\n  <span class=\"amount\">{{ $ctrl.information.amount | currency }}</span>\n</div>\n<p class=\"description\">\n  {{ $ctrl.information.description | translate }}\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/loans.module/features/creditworthiness/creditworthinessCard/creditworthinessCard.html
// module id = 1779
// module chunks = 0